import React from "react";
import "./RegistrationSteps.css";

import {
  FaMobileAlt,
  FaUser,
  FaFileUpload,
  FaUsers,
  FaClipboardCheck,
  FaCreditCard,
  FaArrowRight,
} from "react-icons/fa";

function RegistrationSteps({ onRegisterNow }) {

  const steps = [
    {
      number: "01",
      title: "Mobile Verification",
      description: "Verify your mobile number with OTP.",
      icon: <FaMobileAlt />,
      color: "blue",
    },
    {
      number: "02",
      title: "Personal Details",
      description: "Fill in your basic information.",
      icon: <FaUser />,
      color: "yellow",
    },
    {
      number: "03",
      title: "Document Upload",
      description: "Upload required documents.",
      icon: <FaFileUpload />,
      color: "green",
    },
    {
      number: "04",
      title: "Nominee Details",
      description: "Add nominee information.",
      icon: <FaUsers />,
      color: "red",
    },
    {
      number: "05",
      title: "Review Application",
      description: "Review your details before proceeding.",
      icon: <FaClipboardCheck />,
      color: "purple",
    },
    {
      number: "06",
      title: "Payment & Membership ID",
      description: "Complete payment and get your Membership ID.",
      icon: <FaCreditCard />,
      color: "blue",
    },
  ];

  const handleRegisterNow = () => {
    if (typeof onRegisterNow === "function") {
      onRegisterNow();
      return;
    }

    sessionStorage.setItem("startNewRegistration", "true");
    window.location.href = "/register";
  };

  return (
    <section className="registration-process">

      <div className="registration-process-container">

        {/* ================= HEADER ================= */}

        <div className="registration-process-header">

          <h2>
            Registration <span>Process</span>
          </h2>

          <div className="registration-heading-line"></div>

          <p>
            Complete your membership in six simple steps.
          </p>

        </div>


        {/* ================= STEPS ================= */}

        <div className="registration-steps-wrapper">

          <div className="registration-step-grid">

            {steps.map((step, index) => (
              <React.Fragment key={step.number}>

                <div
                  className={`registration-step-card ${step.color}`}
                >

                  {/* STEP ICON */}

                  <div className="registration-icon-circle">
                    {step.icon}
                  </div>


                  {/* STEP NUMBER */}

                  <div className="registration-number">
                    {step.number}
                  </div>


                  {/* TITLE */}

                  <h3>
                    {step.title}
                  </h3>


                  {/* DESCRIPTION */}

                  <p>
                    {step.description}
                  </p>

                </div>


                {/* ARROW */}

                {index < steps.length - 1 && (
                  <div className="registration-arrow">
                    <FaArrowRight />
                  </div>
                )}

              </React.Fragment>
            ))}

          </div>

        </div>


        {/* ================= REGISTER BUTTON ================= */}

        <div className="registration-button-area">

          <button
            type="button"
            className="registration-process-button"
            onClick={handleRegisterNow}
          >
            Register Now
            <FaArrowRight />
          </button>

        </div>

      </div>

    </section>
  );
}

export default RegistrationSteps;